<template>
  <DropdownTarget
    full-width
    ref="target"
    v-slot="{ show, hide, visible }"
  >
    <TextInput
      v-model.trim="search"
      class="specs-search__input"
      type="search"
      :appearance="search.length ? '' : 'search'"
      :disabled="isDisabled"
      placeholder="Поиск"
      @keyup.enter="show"
      @keyup.esc.stop="hide"
      @update:modelValue="show"
      @click="show"
    >
      <template #icon>
        <span
          v-if="search.length"
          class="specs-search__clear"
          @click="search=''"
          >
          <SvgIcon
            icon="cross"
            size="14"
            color="muted"
          />
        </span>
      </template>
    </TextInput>
    <BasicDropdown
      v-if="visible && search.length"
      full-width
      respect-target
    >
      <div
        v-if="searchResults.length"
        class="specs-search__list">
        <div
          v-for="searchItem in searchResults"
          :key="searchItem.id"
          class="specs-search__item"
          :data-value="searchItem.id"
          @click="addCategory(searchItem)">
          <div class="specs-search__item-group">
            {{ searchItem.groupName }}
          </div>
          <span class="specs-search__item-title">
              {{ searchItem.title }}
            </span>
          <span class="specs-search__item-translation">
              {{ searchItem.translation }}
            </span>
        </div>
      </div>
      <div
        v-else
        class="specs-search__empty"
      >
        Ничего не найдено
      </div>
    </BasicDropdown>
  </DropdownTarget>
</template>

<script>
import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
import TextInput from 'src/components/form/TextInput/TextInput.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'SpecsSearch',
  components: {
    TextInput,
    SvgIcon,
    BasicDropdown,
    DropdownTarget
  },
  props: {
    groups: {
      type: Array,
      required: true,
    },
    isDisabled: Boolean,
  },
  data() {
    return {
      search: '',
      searchResults: [],
    };
  },

  watch: {
    search() {
      this.searchResults = [];
      if (!this.search.length) return;
      
      this.groups.forEach(group => {
        const searchCategories = group.children.filter(child => this.categoryHasSearchQuery(child));
        this.searchResults.push(...searchCategories.map(child => {
          return {
            id: child.id,
            title: child.title,
            translation: child.translation,
            groupName: group.title,
            groupId: group.id
          }
        }))
      });
    },
  },

  methods: {
    categoryHasSearchQuery(category) {
      return category.title.toLowerCase().includes(this.search.toLowerCase())
        || category.translation.toLowerCase().includes(this.search.toLowerCase());
    },

    addCategory(searchCategory) {
      this.$refs.target.hide();
      this.search = '';
      this.$emit('addSearchCategory', searchCategory);
    }
  },
};
</script>

